import localhost from '../../utils/localhost.js';
import axios from 'axios';
import md5 from 'js-md5'

const consult = {
  state: {
    page: 1
  },
  mutations: {
    consultPageUpdate (state, data) {
      state.page = data;
    }
  },
  actions: {

  },
  getters: {}
};

export default consult;



// WEBPACK FOOTER //
// ./src/vuex/modules/consult.js